/**
 * Interleave n arrays, with length being based on shortest.
 * @param  {array} arr n arrays to interleave
 * @return {array}     interleaved array
 */
export default function interleave(...arr) {
  const shortest = arr.reduce(
    (acc, item) => (acc > item.length ? item.length : acc),
    arr[0].length
  );

  const rest = arr.map((item) => item.slice(0, shortest));
  const first = rest.shift();

  return first.reduce(
    (acc, val, idx) => acc.concat(val, ...rest.map((item) => item[idx])),
    []
  );
}



// WEBPACK FOOTER //
// ./app/utils/array/interleave.js